import type { KeyedReturnTypes } from '@gumtree/shared/src/model/generic.model';
import adsenseAds, { updateAdSenseAds } from './adsense-ads';
import bingAds, { updateBingAds } from './bing-ads';
import displayAds, { updateDisplayAds } from './display-ads';
import partnerships, { updatePartnerships } from './partnerships';
import thirdParty, { updateThirdParty } from './third-party';

export const updateBuyerData =
    ({ adsenseAds, bingAds, comScore, displayAds, partnerships }) =>
    (dispatch) => {
        dispatch(updateAdSenseAds(adsenseAds));
        dispatch(updateBingAds(bingAds));
        dispatch(updateDisplayAds(displayAds));
        dispatch(updatePartnerships(partnerships));
        dispatch(updateThirdParty({ comScore }));
    };

const index = {
    adsenseAds,
    bingAds,
    displayAds,
    partnerships,
    thirdParty,
};

export type BuyerAdsState = KeyedReturnTypes<typeof index>;

export default index;
